import { requestApi } from 'api/api'

export const getChatbotAuthToken = async () => {
  return requestApi({
    url: '/accounts-management/v1/support/chat/login',
    method: 'POST',
  })
}
